module.exports = __webpack_public_path__ + "static/media/linkedin_icon.efb02e07.svg";